import { Route, Switch } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import PrivateGuard from "./PrivateGuard";

import Login from "../screens/userAuth/Login";
import Signup from "../screens/userAuth/SignUp";
import VerifyEmail from "../screens/userAuth/VerifyEmail";
import ForgotPassword from "../screens/userAuth/ForgotPassword";
import ResetPassword from "../screens/userAuth/ResetPassword";
import TermsCondition from "../screens/userAuth/TermsCondition";
import PrivacyPolicy from "../screens/userAuth/PrivacyPolicy";
import AcceptablePolicy from "../screens/userAuth/AcceptablePolicy";
import CSAEPolicy from "../screens/userAuth/CSAEPolicy";
import CommunityGuidelines from "../screens/shorts/CommunityGuidelines";
import HelpCenter from "../screens/profile/HelpCenter";
import AboutUs from "../screens/profile/Aboutus";
import LandingPage from "../screens/landing/LandingPage";

const LazyPrivateRoutes = lazy(() => import("./PrivateRoute"));

const Routes: React.FC = () => {
  const isLoggedIn = Boolean(localStorage.getItem("userData"));
  return (
    <Switch>
      <PrivateGuard path="/verify-email" component={VerifyEmail} />
      <PrivateGuard path="/reset-password" component={ResetPassword} />
      <PrivateGuard path="/forgot-password" component={ForgotPassword} />
      <PrivateGuard path="/signup" component={Signup} />
      <PrivateGuard path="/login" component={Login} />
      <Route path="/terms-condition" component={TermsCondition} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/acceptable-policy" component={AcceptablePolicy} />
      <Route path="/csae-policy" component={CSAEPolicy} />
      <Route path="/community-guidelines" component={CommunityGuidelines} />
      {!isLoggedIn && <Route path="/help-center" component={HelpCenter} exact />}
      {!isLoggedIn && <Route path="/Aboutus" component={AboutUs} exact />}
      {!isLoggedIn && <Route path="/" component={LandingPage} exact />}
      <Route path="/">
        <Suspense fallback={<div>Loading...</div>}>
          <LazyPrivateRoutes />
        </Suspense>
      </Route>
    </Switch>
  );
};

export default Routes;
